import React, { Component } from "react";
import { NavLink, BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import AuthService from "./services/auth.service";

import Login from "./components/login.component";
import Register from "./components/register.component";
import Restaurants from "./components/restaurants.component";
import { RoleEnum } from "./services/index.ts";

class App extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);

    this.state = {
      isAdmin: false,
      currentUser: undefined
    };
  }

  componentDidMount() {
    const user = AuthService.getCurrentUser();

    if (user) {
      this.setState({
        currentUser: user,
        isAdmin: user.roles.includes(RoleEnum.admin)
      });
    }
  }

  logOut() {
    AuthService.logout();
  }

  render() {
    const { currentUser, isAdmin } = this.state;

    return (
      <Router>
        <div id="main">
          <nav className="navbar navbar-expand navbar-dark bg-dark">
            <div className="navbar-nav mr-auto">
            {currentUser && (
                <li className="nav-item">
                  <NavLink to={"/restaurants/"} className="nav-link" activeClassName="active">
                    Restaurants
                  </NavLink>
                </li>
						)}

              {isAdmin && (
                <li className="nav-item">
                  <NavLink to={"/users/"} className="nav-link" activeClassName="active">
                    Users
                  </NavLink>
                </li>
              )}

            </div>

            {currentUser ? (
              <div className="navbar-nav ml-auto">
                <li className="nav-item">
                  <a href="/login" className="nav-link" onClick={this.logOut}>
                    LogOut ({currentUser.sub})
                  </a>
                </li>
              </div>
            ) : (
              <div className="navbar-nav ml-auto">
                <li className="nav-item">
                  <NavLink to={"/login"} className="nav-link" activeClassName="active">
                    Login
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to={"/register"} className="nav-link" activeClassName="active">
                    Sign Up
                  </NavLink>
                </li>
              </div>
            )}
          </nav>

          <div className="container mt-3">
            <Switch>
              <Route exact path="/login" component={Login} />
              <Route exact path="/register" component={Register} />
              <Route path="/restaurants" component={Restaurants} />
            </Switch>
          </div>
        </div>
      </Router>
    );
  }
}

export default App;
